<template>
  <v-card class="mb-4">
    <v-card-title class="fontNotoSans700">
      <v-icon>mdi-arrow-left</v-icon>
      서비스 적용 전
    </v-card-title>
    <v-card-text>
      <v-table>
        <thead>
          <tr>
            <th>구분</th>
            <th>기본급</th>
            <th>직무급</th>
            <th>직책수당</th>
            <th>근속수당</th>
            <th>식대</th>
            <th>교통비</th>
            <th>총액</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in wageItems" :key="index">
            <td>{{ item.category }}</td>
            <td>{{ item.basicPay }}</td>
            <td>{{ item.jobPay }}</td>
            <td>{{ item.positionAllowance }}</td>
            <td>{{ item.seniorityAllowance }}</td>
            <td>{{ item.mealAllowance }}</td>
            <td>{{ item.transportationAllowance }}</td>
            <td>{{ item.total }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { WageCompareItem } from '../../../types/wage';

const wageItems = ref<WageCompareItem[]>([
  {
    category: '현행',
    basicPay: 0,
    jobPay: 0,
    positionAllowance: 0,
    seniorityAllowance: 0,
    mealAllowance: 0,
    transportationAllowance: 0,
    total: 0
  }
]);
</script>

<style scoped>
.fontNotoSans700 {
  font-family: 'Noto Sans KR', sans-serif;
  font-weight: 700;
}
</style> 